import React from 'react';
import LoadingSpinner from './LoadingSpinner';

/**
 * Full-screen loader shown while Firebase restores the login on start-up.
 */
const AppLoadingPage = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-ui-page">
      <img src="/assets/logo.png" alt="" className="size-12 object-contain" />
      <LoadingSpinner size="medium" />
      <p className="text-sm text-ui-ink-2">Checking your login…</p>
    </div>
  );
};

export default AppLoadingPage;
